import { Dropdown } from 'tailwindcss-stimulus-components'
export default class ButtonDropdown extends Dropdown {
  teardown() {
    this.menuTarget.classList.add('hidden')
    this.openValue = false
  }
}
